import React from 'react';
import AdminLayout from '../admin/AdminLayout';

export default function CompanyConversations() {
  return (
    <AdminLayout>
      <div style={{ padding: '32px 32px 60px' }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: 'var(--text)' }}>Company Chat</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-muted)', fontSize: 14 }}>Company-wide communication</p>
        </div>

        <div style={{
          background: 'var(--surface)',
          border: '1.5px solid var(--border)',
          borderRadius: 16,
          padding: '60px 40px',
          textAlign: 'center',
          color: 'var(--text-muted)',
        }}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={{ margin: '0 auto 16px', display: 'block', opacity: 0.3 }}>
            <path d="M6 8a3 3 0 013-3h30a3 3 0 013 3v22a3 3 0 01-3 3H16L6 42V8z" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinejoin="round"/>
            <path d="M14 18h20M14 25h12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
          <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>Coming Soon</div>
          <div style={{ fontSize: 14 }}>Company-wide messaging will appear here. This channel is shared across Office Staff, Accounting, and management.</div>
        </div>
      </div>
    </AdminLayout>
  );
}
